export default __webpack_public_path__ + "static/media/s2_male.e2e0856b.wav";